module.exports = __webpack_public_path__ + "static/img/siliconwork-renewal-thumb.2173969.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/siliconwork-renewal-thumb.jpg
// module id = 4wk/
// module chunks = 0